import React, { useCallback, useState } from "react";
import WithdrawalOfMembership from "../components/WithdrawalOfMembership/WithdrawalOfMembership";
import * as apis from "../apis";

export default function WithdrawalOfMembershipContainer() {
  const [removeReason, setRemoveReason] = useState("");

  const handleChagne = useCallback((e) => {
    setRemoveReason(([e.target.name] = e.target.value));
  }, []);

  const handleSubmit = useCallback(async () => {
    try {
      await apis.deleteUser(removeReason);
    } catch (error) {
      console.error(error);
    }
  }, [removeReason]);

  return (
    <WithdrawalOfMembership
      removeReason={removeReason}
      handleChagne={handleChagne}
      handleSubmit={handleSubmit}
    />
  );
}
